import { Location } from '@angular/common';

import { ProductV2 } from '../../core/models/product-v2.model';
import { CartItem } from '../../core/store/cart/cart.state';
import {
  getMindPromoUiFromProduct,
  MindPromoUi,
} from '../../core/utils/mind-price.utils';

export function shouldLoadMindProductDetail(
  explicit: boolean | undefined,
  location: Location,
  pendingMindSlugLoad: boolean
): boolean {
  if (explicit === true) {
    return true;
  }
  if (explicit === false) {
    return false;
  }
  const s = location.getState() as { mindProductDetail?: boolean };
  return !!(s?.mindProductDetail || pendingMindSlugLoad);
}

export function mindProductDetailReloadOptions(
  location: Location,
  pendingMindSlugLoad: boolean,
  currentProduct: ProductV2 | null | undefined
): { mindDetail?: boolean } | undefined {
  const s = location.getState() as { mindProductDetail?: boolean };
  if (s?.mindProductDetail || pendingMindSlugLoad) {
    return { mindDetail: true };
  }
  if (currentProduct?.productType === 'MIND') {
    return { mindDetail: true };
  }
  return undefined;
}

export function isMindProductDetailView(
  currentProduct: ProductV2 | null | undefined,
  location: Location,
  currentProductUuid: string,
  pendingMindSlugLoad: boolean
): boolean {
  if (currentProduct?.productType === 'MIND') {
    return true;
  }
  const nav = location.getState() as { mindProductDetail?: boolean };
  if (currentProductUuid && (nav?.mindProductDetail || pendingMindSlugLoad)) {
    return true;
  }
  return false;
}

export function mindHeroAddToCartShouldDisable(
  items: CartItem[],
  currentProduct: ProductV2 | null | undefined,
  currentProductUuid: string
): boolean {
  const uuid = (currentProduct?.uuid || currentProductUuid || '').trim();
  const sku = (currentProduct?.sku || '').trim();

  return items.some(i => {
    const p = i.product;
    if (p?.productType !== 'MIND') {
      return false;
    }
    if (uuid && (p.uuid === uuid || String(p.id) === uuid)) {
      return true;
    }
    if (sku && p.sku === sku) {
      return true;
    }
    return false;
  });
}

export function computeMindHeroAddToCartDisabled(
  items: CartItem[],
  currentProduct: ProductV2 | null | undefined,
  currentProductUuid: string,
  location: Location,
  pendingMindSlugLoad: boolean
): boolean {
  if (
    !isMindProductDetailView(
      currentProduct,
      location,
      currentProductUuid,
      pendingMindSlugLoad
    )
  ) {
    return false;
  }
  return mindHeroAddToCartShouldDisable(
    items,
    currentProduct,
    currentProductUuid
  );
}

export function mindCatalogHeroPrice(product: ProductV2 | null | undefined): number {
  if (!product || product.productType !== 'MIND') {
    return 0;
  }
  const promo = getMindPromoUiFromProduct(product);
  if (promo) {
    return promo.displayPrice;
  }
  return product.salesPrice ?? product.price ?? 0;
}

export function mindCatalogHeroPromo(
  product: ProductV2 | null | undefined
): MindPromoUi | null {
  return getMindPromoUiFromProduct(product);
}
